const messages = {
  title: 'Notranja napaka',
  description: 'Podatki za to stran ne morejo biti pravilno naloženi.',
  backHomeButton: 'Nazaj na nadzorno ploščo'
}

export default {
  messages
}
